/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useQuery } from '@apollo/client';

export const useGetAddress = (addressId,skip:boolean) => {
    
  const { loading, data, error, refetch } = useQuery(
    gql`
     query GetAddressById($addressId: String!) {
  customerGetAddress(addressId: $addressId) {
    id
    title
    titleCode
    address1
    address2
    city
    company
    country
    countryCode
    countryName
    firstName
    lastName
    name
    phone
    phone2
    province
    zip
    email
    availableForShipping
    availableForBilling
    address3
    phoneExt
    identification
    dateOfBirth
    personTitle
    businessTitle
    orderId
    storeField1
    storeField2
  }
}

    `,
    { 
        variables:{addressId:addressId},
        fetchPolicy:'network-only',
        skip:skip
    }
  );
  return {  loading, error, addressData: data, refetch};
};